import { FC, ReactNode } from 'react';
import { Box, styled } from '@mui/material';

const Message = styled(Box, {
  shouldForwardProp: (prop: string) => !['variant', 'centered'].includes(prop),
})<{
  variant: MessageType['variant'];
  centered?: boolean;
}>(({ theme, variant, centered }) => ({
  width: '100%',
  padding: theme.spacing(theme.spacingSizes.xs, theme.spacingSizes.xl),
  color: theme.palette[variant].contrastText,
  backgroundColor: theme.palette[variant].light,
  textAlign: centered ? 'center' : undefined,
  fontSize: theme.fontSizes.regular,
  lineHeight: '150%',
}));

export type MessageType = {
  key: string;
  content: ReactNode;
  variant: 'primary' | 'secondary' | 'info' | 'success' | 'error' | 'warning';
  centered?: boolean;
};

const PageMessages: FC<{ messages: Array<MessageType> }> = ({ messages }) => {
  return (
    <>
      {messages
        .filter((message) => message.content)
        .map((message) => (
          <Message
            key={message.key}
            variant={message.variant}
            centered={message.centered}
          >
            {message.content}
          </Message>
        ))}
    </>
  );
};

export default PageMessages;
